// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2X9Q_","list":"PatternAutocomplete_list__2-DNG"};